// === Planet price hook (mínimo y robusto) ===
(function () {
  // Helpers
  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));
  const parseJSON = el => { try { return JSON.parse(el.textContent); } catch { return null; } };

  function scopeProduct(el){
    return el.closest('section, form[action^="/cart/add"], .product, .product__info, .product-view, .product-section') || document;
  }

  function getProductJSON(ctx){
    let s = $('script[type="application/json"][data-product]', ctx)
          || $('script[type="application/json"][id^="ProductJson-"]', ctx)
          || $('script[type="application/json"][data-product]', document);
    return s ? parseJSON(s) : null;
  }

  function currentVariant(ctx){
    const idEl = $('form[action^="/cart/add"] input[name="id"]', ctx);
    const id = idEl && idEl.value ? String(idEl.value) : null;
    if (!id) return null;
    const data = getProductJSON(ctx);
    if (!data || !Array.isArray(data.variants)) return null;
    return data.variants.find(v => String(v.id) === id) || null;
  }

  // Acepta el HTML formateado de Planet (ya incluye <span class="money">…</span>)
  function setMoney(el, formattedHtml){
    if (!el) return;
    el.innerHTML = formattedHtml;
  }

  // Normaliza/crea el bloque de "sale" con la estructura esperada (s/ins)
  function ensureSaleBlock(root) {
    const container = root.querySelector('.price__container') || root;

    // etiquetas accesibles del tema
    const labelR = container.getAttribute('data-label-price-regular') || 'Precio regular';
    const labelS = container.getAttribute('data-label-price-sale') || 'Precio de oferta';

    // oculta el bloque regular si existe
    const regular = root.querySelector('.price__regular');
    if (regular) regular.style.display = 'none';

    // busca (o crea) el bloque sale y reconstituye si está incompleto
    let sale = root.querySelector('.price__sale');
    if (!sale) {
      sale = document.createElement('div');
      sale.className = 'price__sale';
      container.appendChild(sale);
    }
    const hasS = !!sale.querySelector('s');
    const hasIns = !!sale.querySelector('ins');
    if (!hasS || !hasIns) {
      sale.innerHTML = `
        <div class="price__sale-inner">
          <span class="visually-hidden">${labelR}</span>
          <s class="js-price-compare"><span class="money"></span></s>
          <span class="visually-hidden">${labelS}</span>
          <ins class="js-price-current js-price-current-sale"><span class="money"></span></ins>
        </div>
      `;
    }

    return {
      compareEl: sale.querySelector('.js-price-compare') || sale.querySelector('s'),
      currentEl: sale.querySelector('.js-price-current-sale') || sale.querySelector('ins, .js-price-current')
    };
  }

  // Lógica: calcula y aplica en UNA instancia (PDP)
  function applyInRoot(root){
    if (!root) return;

    const payloadEl = $('.planet-price-payload', root);
    const payload = payloadEl ? (parseJSON(payloadEl) || {}) : {};
    const ctx = scopeProduct(root);

    const vNow = currentVariant(ctx);
    const variant = vNow || payload.variant || variantFromDataAttr(root, ctx);
    if (!variant) return;

    const metaobjectVariant = payload.metaobjectVariant;
    const fn = window.PlanetDataset && window.PlanetDataset.getDiscountForVariant;
    if (typeof fn !== 'function') return;

    const prices = fn(variant, metaobjectVariant);
    if (!prices) return;

    const hasDeal = (typeof prices.discount === 'number' && prices.discount > 0)
                 || (typeof prices.compareAtPrice === 'number' && typeof prices.price === 'number' && prices.compareAtPrice > prices.price);

    // Si no hay descuento en esta variante, oculta badge (si lo hubiera) y no pintes sale
    if (!hasDeal) {
      if (window.__planet?.removeBadge) window.__planet.removeBadge(root);
      return;
    }

    // Idempotencia: no reescribir si ya están estos valores
    const signature = String(prices.priceFormated) + '|' + String(prices.compareAtPriceFormated) + '|' + String(variant.id);
    if (root.dataset.planetSig === signature) return;

    const { compareEl, currentEl } = ensureSaleBlock(root);
    setMoney(currentEl, prices.priceFormated);
    setMoney(compareEl, prices.compareAtPriceFormated);
    root.classList.add('price--on-sale');

    if (window.__planet?.upsertBadge) {
      window.__planet.upsertBadge(root, prices);
    }
    root.dataset.planetSig = signature;
  }

  function variantFromDataAttr(root, ctx){
    const id = root.getAttribute('data-variant-id');
    if (!id) return null;
    const data = getProductJSON(ctx);
    if (data && Array.isArray(data.variants)){
      const v = data.variants.find(v => String(v.id) === String(id));
      if (v) return v;
    }
    return { id: Number(id) || id };
  }

  function applyAll(scope){
    $$('.js-price-root', scope || document).forEach(applyInRoot);
  }

  // Espera a Planet (poll + evento opcional)
  function whenPlanetReady(cb){
    if (typeof window.PlanetDataset?.getDiscountForVariant === 'function') { cb(); return; }
    let tries = 0, max = 120; // ~36s a 300ms
    const t = setInterval(() => {
      if (typeof window.PlanetDataset?.getDiscountForVariant === 'function') {
        clearInterval(t); cb();
      } else if (++tries >= max) {
        clearInterval(t);
      }
    }, 300);
    document.addEventListener('planet:ready', () => { cb(); }, { once:true });
  }

  // Hooks
  document.addEventListener('DOMContentLoaded', function(){
    ensureProductBadgeStyles();
    whenPlanetReady(() => applyAll(document));
  });

  function reapplyFromEvent(e){
    whenPlanetReady(() => {
      const scope = scopeProduct(e.target instanceof Element ? e.target : document.body);
      applyAll(scope);
    });
  }

  // Eventos comunes de cambio de variante (PDP)
  document.addEventListener('variant:change', reapplyFromEvent);
  document.addEventListener('variant-change', reapplyFromEvent);

  // Fallback: cambio del input hidden de variante
  document.addEventListener('change', function(e){
    const el = e.target;
    if (el instanceof Element && el.matches('form[action^="/cart/add"] input[name="id"]')) {
      reapplyFromEvent(e);
    }
  });

  // Re-render del bloque (limitado y sin forzar reflow)
  let moTimer = null;
  const rootScope = document.body; // si quieres, cámbialo por el contenedor de PDP
  const mo = new MutationObserver(() => {
    if (moTimer) return;
    moTimer = setTimeout(() => { whenPlanetReady(() => applyAll(rootScope)); moTimer = null; }, 50);
  });
  mo.observe(rootScope, { childList: true, subtree: true });

  // === BADGES LOCALIZADOS ===

  // Lee config desde <script id="planet-badge-config">
  function getPlanetBadgeConfig(){
    const el = document.getElementById('planet-badge-config');
    if (!el) return { template: '-__PCT__%', classes: 'product-card__badge product-card__badge--discount' };
    try { return JSON.parse(el.textContent); }
    catch { return { template: '-__PCT__%', classes: 'product-card__badge product-card__badge--discount' }; }
  }
  const _badgeCfg = getPlanetBadgeConfig();

  function formatDiscountBadge(pct){
    return (_badgeCfg.template || '-__PCT__%').replace('__PCT__', String(pct));
  }

  function upsertPlanetBadgeLocalized(root, prices) {
    if (typeof prices.compareAtPrice !== 'number' || typeof prices.price !== 'number') { removePlanetBadge(root); return; }
    const denom = prices.compareAtPrice, numer = denom - prices.price;
    const pct = Math.round((numer / (denom || 1)) * 100);
    if (!isFinite(pct) || pct <= 0) { removePlanetBadge(root); return; }

    const card = root.closest('.product-card, .card-wrapper, .product-grid__item, .product, .product-item, section') || root;

    // contenedor
    let container = card.querySelector('.product-card__badges');
    if (!container) {
      container = document.createElement('span');
      container.className = 'product-card__badges';
      const priceContainer = card.querySelector('.price__container') || root;
      priceContainer.parentNode.insertBefore(container, priceContainer);
    }

    // badge
    let badge = container.querySelector('.planet-badge-discount');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = _badgeCfg.classes + ' planet-badge-discount';
      container.appendChild(badge);
    }

    const formatted = formatDiscountBadge(pct);
    // si tu tema usa <span class="percentage">21</span>% de descuento, crea esa estructura
    badge.innerHTML = formatted.replace(/(\d+)\s*%/, '<span class="percentage">$1</span>%');
    badge.classList.remove('hidden');
  }

  function ensureProductBadgeStyles() {
    if (document.querySelector('link[data-planet-badge-css]')) return;

    const href = window.__planetBadgeCSS;
    if (!href) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'print';
    link.onload = () => (link.media = 'all');
    link.setAttribute('data-planet-badge-css', 'true');
    document.head.appendChild(link);

    // variables de color del tema
    const vars = window.__planetBadgeVars || {};
    const style = document.createElement('style');
    style.textContent = `
      :root {
        --color-badge-discount-background: ${vars.bg || '#000'};
        --color-badge-discount-foreground: ${vars.fg || '#fff'};
      }
    `;
    document.head.appendChild(style);
  }

  function removePlanetBadge(root){
    const card = root.closest('.product-card, .card-wrapper, .product-grid__item, .product, .product-item, section') || root;
    const badge = card.querySelector('.planet-badge-discount');
    if (badge) badge.classList.add('hidden');
  }

  // --- expón helpers de badge para que el patch de cards pueda usarlos ---
  window.__planet = window.__planet || {};
  window.__planet.upsertBadge = upsertPlanetBadgeLocalized;
  window.__planet.removeBadge = removePlanetBadge;
})();

/* ===== Planet: product-cards — hook mínimo y seguro ===== */
(function(){
  const SEL_CARD = 'product-card, .product-card';

  // Helpers
  const $ = (sel, r=document) => r.querySelector(sel);
  const $$ = (sel, r=document) => Array.from(r.querySelectorAll(sel));
  // Acepta HTML formateado de Planet
  const setMoney = (el, f) => { if (el) el.innerHTML = f; };

  // Normaliza/crea el bloque sale y reconstituye si está incompleto
  function ensureSale(root){
    const container = $('.price__container', root) || root;
    const labelR = container?.getAttribute('data-label-price-regular') || 'Regular price';
    const labelS = container?.getAttribute('data-label-price-sale') || 'Sale price';

    const regular = $('.price__regular', root);
    if (regular) regular.style.display = 'none';

    let sale = $('.price__sale', root);
    if (!sale) {
      sale = document.createElement('div');
      sale.className = 'price__sale';
      container.appendChild(sale);
    }
    const hasS = !!sale.querySelector('s');
    const hasIns = !!sale.querySelector('ins');
    if (!hasS || !hasIns) {
      sale.innerHTML = `
        <div class="price__sale-inner">
          <span class="visually-hidden">${labelR}</span>
          <s class="js-price-compare"><span class="money"></span></s>
          <span class="visually-hidden">${labelS}</span>
          <ins class="js-price-current js-price-current-sale"><span class="money"></span></ins>
        </div>`;
    }

    return {
      compareEl: $('.js-price-compare', sale) || $('s', sale),
      currentEl: $('.js-price-current-sale', sale) || $('ins, .js-price-current', sale)
    };
  }

  // Lee variantes embebidas + opciones seleccionadas
  function getVariantsFromCard(card){
    const s = $('script[type="application/json"][data-product-variants-json], script[type="application/json"][data-product-variants], script[type="application/json"][data-product-variants-json=""]', card);
    if (!s) return [];
    try { return JSON.parse(s.textContent) || []; } catch { return []; }
  }
  function getSelectedOptions(card){
    const sel = n => $(`input[type="radio"][name$="option[${n}]"]:checked`, card)?.value || null;
    return [sel(1), sel(2), sel(3)];
  }
  function getVariantByOptions(card){
    const [o1,o2,o3] = getSelectedOptions(card);
    const arr = getVariantsFromCard(card);
    if (!arr.length) return null;
    return arr.find(v =>
      (o1 ? v.option1 === o1 : true) &&
      (o2 ? v.option2 === o2 : true) &&
      (o3 ? v.option3 === o3 : true)
    ) || null;
  }

  // Aplica Planet en UNA instancia .js-price-root con la variante dada (CARD)
  function applyPlanetInRoot(root, variant){
    const payloadEl = $('.planet-price-payload', root);
    let payload = null;
    try { payload = payloadEl ? JSON.parse(payloadEl.textContent) : null; } catch {}
    const metaobjectVariant = payload ? payload.metaobjectVariant : null;

    const fn = window.PlanetDataset && window.PlanetDataset.getDiscountForVariant;
    if (typeof fn !== 'function' || !variant) return;

    const prices = fn(variant, metaobjectVariant);
    const hasDeal = prices && (
      (typeof prices.discount === 'number' && prices.discount > 0) ||
      (typeof prices.compareAtPrice === 'number' && typeof prices.price === 'number' && prices.compareAtPrice > prices.price)
    );

    if (!hasDeal) {
      if (window.__planet?.removeBadge) window.__planet.removeBadge(root);
      return;
    }

    const { compareEl, currentEl } = ensureSale(root);
    setMoney(currentEl, prices.priceFormated);
    setMoney(compareEl, prices.compareAtPriceFormated);
    root.classList.add('price--on-sale');

    if (window.__planet?.upsertBadge) {
      try { window.__planet.upsertBadge(root, prices); } catch {}
    }
  }

  // Reaplica en todas las instancias de precio dentro de la card
  function applyPlanetInCard(card){
    const variant = getVariantByOptions(card) || (function(){
      const id = $('input[name="id"]', card)?.value; return id ? { id } : null;
    })();
    if (!variant) return;

    // sincroniza hidden id para coherencia con otros scripts del tema
    const idEl = $('input[name="id"]', card);
    if (idEl && String(idEl.value) !== String(variant.id)) idEl.value = String(variant.id);

    $$('.js-price-root', card).forEach(root => {
      root.setAttribute('data-variant-id', String(variant.id));
      applyPlanetInRoot(root, variant);
    });
  }

  // Throttle por card
  const pending = new WeakMap();
  function scheduleApply(card){
    if (!card || pending.get(card)) return;
    pending.set(card, true);
    requestAnimationFrame(() => { pending.delete(card); applyPlanetInCard(card); });
  }

  // Cablea una card (listeners livianos)
  function wireCard(card){
    if (!card || card.__planetCardWired) return;
    card.__planetCardWired = true;

    // change en radios / swatches / hidden id
    card.addEventListener('change', (e) => {
      if (e.target.matches('.js-product-card-options input, .product-card__variants input, .variant-option-radio-input, input[name="id"]')) {
        setTimeout(() => scheduleApply(card), 0);
      }
    });

    // click en labels/botones de variante (por si el tema retrasa el checked)
    card.addEventListener('click', (e) => {
      if (e.target.closest('.product-card__variants label, .button--variant, .product-option__label')) {
        setTimeout(() => scheduleApply(card), 0);
      }
    });

    // primera pasada (cuando Planet esté listo)
    (function waitPlanet(t=0){
      if (typeof window.PlanetDataset?.getDiscountForVariant === 'function') scheduleApply(card);
      else if (t < 120) setTimeout(() => waitPlanet(t+1), 300);
    })();
  }

  // Inicializa cards presentes y futuras (MO ligero solo para altas de cards)
  function initCards(){
    $$(SEL_CARD).forEach(wireCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCards);
  else initCards();

  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches?.(SEL_CARD)) wireCard(node);
        node.querySelectorAll?.(SEL_CARD).forEach(wireCard);
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
